import toastr from 'react-hot-toast';
import {useMutation} from 'react-query';
import {fetchWrapper} from 'utils/fetchWrapper';
import type {
  SingleMemoryCategoryResponse,
  MemoryCategoryAttribute,
} from 'types/Memory';

type MutationVariables = Pick<
  MemoryCategoryAttribute,
  'categoryID' | 'memoryID'
>;

export function useAddMemoryCategory() {
  const addMemoryCategory = (memoryCategoryAttributes: MutationVariables) => {
    const body = {
      data: {
        type: 'memoryCategories',
        attributes: memoryCategoryAttributes,
      },
    };
    return fetchWrapper<SingleMemoryCategoryResponse>({
      url: `memoryCategories`,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addMemoryCategory', addMemoryCategory, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to add Memory Category: ${error.message}`);
      }
    },
  });
}
